import { useState } from 'react';
import { Configuration, FrontendApi, Session } from '@ory/client';
import { ConfigurationParameters } from '@ory/client/configuration';

import { authActions } from '../../store/auth/auth';
import { useAppActions } from '../../utils/hooks';
import { useLazyGetSessionQuery } from '../../api';

export const oryLoginUrl = `${process.env.REACT_APP_UI_ORY_SDK_URL}/login?return_to=${window.location.href}`;
export const redirectToOryLogin = () => window.location.replace(oryLoginUrl);

export type Traits = Record<string, unknown>;

// creating ory instance
export const createOry = (config: ConfigurationParameters) => {
  return new FrontendApi(new Configuration(config));
};

export const useOry = async (ory: FrontendApi, basePath: string) => {
  const { setAuthStatus, setTraits, setLogoutUrl, setUserUid } = useAppActions(authActions);

  const [session, setSession] = useState<Session | undefined>();
  const [hasSession, setSessionStatus] = useState(false);
  const [getWhoami] = useLazyGetSessionQuery();

  // ory initialization
  // const initOry = (ory: FrontendApi, basePath: string) => {
  await getWhoami()
    .then(({ data }) => {
      setSession(data?.session);
      setSessionStatus(true);

      setAuthStatus(true);

      console.log('oryLoginUrl', oryLoginUrl);
      window.location.replace(oryLoginUrl);
    })
    .catch(() => {
      console.log('catch');
      // const loginUrl = `${oryLoginUrl}?return_to=https://${window.location.host}`;
      // window.location.replace(loginUrl);
      // redirectToOryLogin();
    });
  // };
};
